import debounce from 'lodash/debounce';
import dayjs from 'dayjs';
import { apis, environment } from '@/config';
import { api } from '@/api/api';
import { toJson } from '@/api/util';
import { eventLoggerDbImpl } from './event_logger_db_helper';
import { wait } from '@/api/util/index';
import { getOs } from '../../../utils/confOs';
const desktopOs = getOs() === 'mac' ? 'mac' : 'win';
const env = typeof environment === 'string' ? environment : 'local';
const isDev = !['test_prod', 'prod', 'prev'].includes(env);
class LoggerApiImpl {
    constructor() {
        this.flushing = false;
        this.logWriteinConfig = {
            high: {
                lstSetTime: Date.now(),
                cacheLimit: 20,
                waitTrackList: new Map(),
                expiredSpan: 30 * 1000,
                LOG_DELAY: 200,
                flushing: false,
            },
            normal: {
                lstSetTime: Date.now(),
                cacheLimit: 100,
                waitTrackList: new Map(),
                expiredSpan: 3 * 60 * 1000,
                LOG_DELAY: 1000,
                flushing: false,
            },
            low: {
                lstSetTime: Date.now(),
                cacheLimit: 40,
                waitTrackList: new Map(),
                expiredSpan: 8 * 60 * 1000,
                LOG_DELAY: 3000,
                flushing: false,
            },
        };
        this.lstSetTime = Date.now();
        this.loggerCacheLimit = 40;
        this.winId = -2;
        this.processId = 'unknown';
        this.LOG_DELAY = 1000;
        this.eventDbLogger = eventLoggerDbImpl;
        this.lastEventTime = 0;
        this.platform = process.env.BUILD_ISELECTRON ? desktopOs : 'web';
        this.forbidden_writelog = false;
        this.trackCommonOption = {
            domain: '',
            orgName: '',
            threadMode: '',
            userAccount: '',
            logginStatus: '',
        };
        this.traceId = 'event-traceid-' + Date.now();
        this.updateTraceIdToken = null;
        this.traceIdMap = new Map();
        this.requestIdleCallbackId = null;
        this.asyncFlushHandler = null;
        this.name = apis.loggerApiImpl;
        this.eventApi = api.getEventApi();
        this.systemApi = api.getSystemApi();
        this.storeApi = api.getDataStoreApi();
        this.httpApi = api.getDataTransApi();
        this.fileApi = api.getFileApi();
        this.feedbackApi = api.requireLogicalApi(apis.feedbackApiImpl);
        this.mailApi = api.requireLogicalApi(apis.mailApiImpl);
        this.loginApi = api.requireLogicalApi(apis.loginApiImpl);
        this.productAuthApi = api.requireLogicalApi(apis.productAuthApiImpl);
        this.isLogout = false;
        this.debounceDbLoggerPut = debounce(this.debounceDbLoggerPut, this.LOG_DELAY, { leading: true });
        this.dateTrackerApi = api.requireLogicalApi(apis.dataTrackerApiImp);
    }
    static getInstance() {
        return LoggerApiImpl._logger;
    }
    getUrl(url) {
        return this.systemApi.getUrl(url);
    }
    parseResult(res) {
        return res.data;
    }
    catchError(reason) {
        return reason;
    }
    init() {
        if (this.systemApi.isElectron()) {
            this.systemApi.getCurrentWinInfo(true).then(currentWinInfo => {
                this.winId = currentWinInfo.webId;
            });
            if (window.process && window.process.pid) {
                this.processId = window.process.pid + ':' + window.process.ppid;
            }
        }
        this.systemApi.getDeviceInfo().then(value => {
            this.deviceInfo = value;
        });
        return this.name;
    }
    afterInit() {
        this.user = this.systemApi.getCurrentUser();
        this.uuid = this.storeApi.getUUID();
        if (!isDev) {
            this.systemApi.intervalEvent({
                seq: 0,
                eventPeriod: 'long',
                handler: ev => {
                    if (ev.seq > 1) {
                        this.track('tick', {}, 'low');
                        this.forbidden_writelog = this.productAuthApi.getABSwitchSync('forbidden_writelog');
                    }
                },
            });
        }
        this.eventDbLogger.init();
        return this.name;
    }
    afterLogin() {
        this.user = this.systemApi.getCurrentUser();
        this.isLogout = false;
        this.eventDbLogger.init();
        return this.name;
    }
    afterLoadFinish() {
        if (!isDev) {
            this.logReport();
        }
        return this.name;
    }
    beforeLogout() {
        this.isLogout = true;
        this.eventDbLogger.close();
        return this.name;
    }
    logReport() {
        this.systemApi.intervalEvent({
            seq: 0,
            eventPeriod: 'extLong',
            handler: ev => {
                const seq = ev.seq || 0;
                if (seq > 0 && seq % 6 === 1) {
                    this.getLogConfig({
                        productId: process.env.BUILD_ISEDM ? 'fastmail' : 'sirius',
                        platform: this.platform,
                    }).then(res => {
                        var _a, _b, _c;
                        if ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusSwitch) {
                            this.startUploadLog((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.timeSpan, (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.recallId);
                        }
                    });
                }
            },
        });
    }
    getLogConfig(option) {
        return this.httpApi.get(this.getUrl('getLogConfig'), option, { contentType: 'json' }).then(this.parseResult).catch(this.catchError);
    }
    uploadLog(option) {
        return this.httpApi.post(this.getUrl('uploadLog'), option, { contentType: 'json' }).then(this.parseResult).catch(this.catchError);
    }
    async startUploadLog(timeSpan, recallId) {
        var _a, _b, _c, _d;
        let logFile = new File([], '');
        let fileName = `clieng-log/sirius/${this.platform}/${(_a = this.user) === null || _a === void 0 ? void 0 : _a.id}/${Date.now()}-0`;
        const period = timeSpan || 1;
        if (process.env.BUILD_ISELECTRON) {
            const res = await ((_c = (_b = window.electronLib) === null || _b === void 0 ? void 0 : _b.fsManage) === null || _c === void 0 ? void 0 : _c.logsToArrayBuf(period));
            if (!(res === null || res === void 0 ? void 0 : res.data)) {
                return;
            }
            fileName = `${fileName}.zip`;
            logFile = new File([res === null || res === void 0 ? void 0 : res.data], fileName, { type: 'application/zip' });
        }
        else {
            const webLogMap = await this.getWebLogs(period * 24 * 3600 * 1000);
            const logBlobArray = [...webLogMap.values()];
            if (!logBlobArray || !logBlobArray.length) {
                return;
            }
            fileName = `${fileName}.log`;
            logFile = new File(logBlobArray, fileName);
        }
        const uploadRes = await this.uploadNosMediaOrLog(logFile, fileName, 'log');
        if (uploadRes === 'success') {
            const deviceInfo = await this.systemApi.getDeviceInfo();
            const params = {
                productId: process.env.BUILD_ISEDM ? 'fastmail' : deviceInfo.p,
                recallId,
                deviceId: '',
                platform: this.platform,
                version: window === null || window === void 0 ? void 0 : window.siriusVersion,
                systemVersion: deviceInfo._systemVersion,
                email: ((_d = this.user) === null || _d === void 0 ? void 0 : _d.id) || '',
                files: [
                    {
                        type: 'log',
                        name: fileName,
                        fileCreateTime: Date.now(),
                        size: logFile.size,
                    },
                ],
            };
            this.uploadLog(params);
        }
    }
    async getWebLogs(period) {
        const logMap = (await this.getLogger(period)) || {};
        const entries = Object.entries(logMap).map(item => {
            const [key, log] = item;
            const logsStr = (log || []).map(item => {
                try {
                    item.data = JSON.parse(item.data);
                }
                catch (e) { }
                return JSON.stringify(item);
            });
            const r = navigator.appVersion.indexOf('Win') !== -1 ? '\r\n\n' : '\n\n';
            const blob = new Blob([logsStr.join(r)]);
            return [key, blob];
        });
        return new Map(entries);
    }
    async uploadNosMediaOrLog(file, fileName, type, isLoginType = false) {
        const tokenRes = isLoginType ? await this.feedbackApi.getNosTokenNoLogin({ fileName }) : await this.feedbackApi.getNosToken({ fileName });
        if (tokenRes === null || tokenRes === void 0 ? void 0 : tokenRes.data) {
            const uploadUrl = this.systemApi.getUrl('mailAttachmentUploadHost') + tokenRes.data.bucketName + '/' + tokenRes.data.objectName;
            const shardObj = this.mailApi.buildAttachmentSliceUploader({}, {
                file: file,
                id: 0,
                type: type === 'log' ? type : 'mmc',
                fileName,
                fileSize: file.size,
            }, tokenRes.data, tokenRes.data);
            const uploadRes = await this.fileApi.uploadPieceByPiece(uploadUrl, {
                fileName,
                file: file,
                fileSize: file.size,
            }, shardObj);
            if ((uploadRes === null || uploadRes === void 0 ? void 0 : uploadRes.statusText) === 'OK') {
                return 'success';
            }
        }
        return 'fail';
    }
    formatContent(eventId, attributes) {
        var _a, _b, _c, _d;
        const now = (attributes === null || attributes === void 0 ? void 0 : attributes.eventTime) || Date.now();
        if (this.lastEventTime >= now) {
            this.lastEventTime = now;
            return undefined;
        }
        if (process.env.BUILD_ISLINGXI) {
            return {
                date: now,
                user: (_a = this.user) === null || _a === void 0 ? void 0 : _a.id,
                uuid: this.uuid,
                sid: (_b = this.user) === null || _b === void 0 ? void 0 : _b.sessionId,
                eventId,
                pid: this.processId,
                winId: this.winId,
                data: attributes,
                curPath: window.location.pathname,
                appendix: attributes === null || attributes === void 0 ? void 0 : attributes.appendix,
            };
        }
        this.updateTraceIdToken && clearTimeout(this.updateTraceIdToken);
        this.updateTraceIdToken = setTimeout(() => {
            this.traceIdMap.clear();
            this.traceId = 'event-traceid-' + Date.now();
        }, 0);
        if (this.traceIdMap.has(this.traceId)) {
            const obj = this.traceIdMap.get(this.traceId);
            obj.count += 1;
            this.traceIdMap.set(this.traceId, obj);
        }
        else {
            this.traceIdMap.set(this.traceId, {
                count: 1,
                startEvent: eventId,
                startTime: Date.now(),
            });
        }
        const { startTime = 0, count = 0, startEvent = '' } = this.traceIdMap.get(this.traceId) || {};
        if (startTime && (count >= 100 || now - startTime > 2000)) {
            setTimeout(() => {
                const obj = {
                    reason: count > 100 ? 'many' : 'slow',
                    count,
                    traceId: this.traceId,
                    duration: now - startTime,
                    startEventId: startEvent,
                    endEvent: eventId,
                };
                this.dateTrackerApi.track('toMuchOrToSlowLogger', obj || {}, true);
            }, 10000);
        }
        return {
            date: now,
            user: (_c = this.user) === null || _c === void 0 ? void 0 : _c.id,
            uuid: this.uuid,
            sid: (_d = this.user) === null || _d === void 0 ? void 0 : _d.sessionId,
            eventId,
            pid: this.processId,
            winId: this.winId,
            data: attributes,
            curPath: window.location.pathname,
            appendix: attributes === null || attributes === void 0 ? void 0 : attributes.appendix,
            _traceId: this.traceId,
        };
    }
    formatTime(now) {
        return dayjs(now).format('YYYY-MM-DD HH:mm:ss');
    }
    track(eventId, attributes, priority = 'normal') {
        if (this.forbidden_writelog) {
            return;
        }
        try {
            const data = this.formatContent(eventId, attributes);
            if (data) {
                const trackKey = `${eventId}_${data.date}`;
                this.cacheLog(trackKey, data, priority);
                this.checkFlush(priority);
            }
        }
        catch (e) {
            console.warn('[logger] error', e);
        }
    }
    cacheLog(key, value, priority) {
        const writeConfig = this.logWriteinConfig[priority];
        const { waitTrackList, cacheLimit } = writeConfig;
        if (waitTrackList.get(key) === undefined) {
            waitTrackList.set(key, value);
            writeConfig.lstSetTime = Date.now();
        }
        if (process.env.BUILD_ISEDM && waitTrackList.size >= 2 * cacheLimit) {
            waitTrackList.forEach(item => {
                (item === null || item === void 0 ? void 0 : item.data) && (item.data = 'attr hasbeen removed.');
            });
        }
        if (priority !== 'low') {
            return;
        }
        while (waitTrackList.size > cacheLimit) {
            [...waitTrackList.keys()].forEach((loggerKey, index) => {
                if (index % 2) {
                    waitTrackList.delete(loggerKey);
                }
            });
        }
    }
    checkFlush(priority) {
        const { waitTrackList, lstSetTime, expiredSpan, cacheLimit, flushing } = this.logWriteinConfig[priority];
        if (flushing || !waitTrackList || !waitTrackList.size) {
            return;
        }
        if (waitTrackList.size >= cacheLimit) {
            const hasExceedLimit = waitTrackList.size >= 2 * cacheLimit;
            this.syncFlush(priority, hasExceedLimit);
        }
        else if (lstSetTime + expiredSpan < Date.now()) {
            this.syncFlush(priority);
        }
    }
    syncFlush(priority, isForce = false) {
        try {
            if (window === null || window === void 0 ? void 0 : window.requestIdleCallback) {
                this.requestIdleCallbackId && window.cancelIdleCallback(this.requestIdleCallbackId);
                const num = window.requestIdleCallback(() => {
                    this.flush(priority);
                });
                if (!isForce) {
                    this.requestIdleCallbackId = num;
                }
            }
            else {
                this.asyncFlushHandler && clearTimeout(this.asyncFlushHandler);
                const num = setTimeout(() => {
                    this.flush(priority);
                }, 0);
                if (isForce) {
                    this.asyncFlushHandler = num;
                }
            }
        }
        catch (error) {
            console.warn('log impl flush error', error);
        }
    }
    async flush(priority = 'normal') {
        try {
            await this.flushAndRecordEvent(priority);
        }
        catch (ex) { }
        const logWriteConfigItem = this.logWriteinConfig[priority];
        logWriteConfigItem.flushing = false;
    }
    getLogger(period, endTimestamp) {
        return this.eventDbLogger.getByPeriod(period, endTimestamp);
    }
    debounceDbLoggerPut(data, priority) {
        this.eventDbLogger.put(data, priority);
    }
    async flushAndRecordEvent(priority) {
        const logWriteinConfigItem = this.logWriteinConfig[priority];
        const { flushing, waitTrackList } = logWriteinConfigItem;
        if (flushing) {
            return Promise.reject(new Error('日志写入正在进行中'));
        }
        console.warn('[event_logger]flushAndRecordEvent.true', priority, logWriteinConfigItem, this.logWriteinConfig);
        const inElectron = process.env.BUILD_ISELECTRON && window.electronLib;
        logWriteinConfigItem.flushing = true;
        const dtMapInElectron = new Map();
        const dtMapInWeb = new Map();
        const defaultAppendix = priority !== 'normal' ? priority : '__default';
        const used = [];
        waitTrackList.forEach((value, key) => {
            var _a;
            used.push(key);
            if (!value) {
                return;
            }
            value._dateStr = this.formatTime(new Date(value.date));
            value.deviceId = (_a = this.deviceInfo) === null || _a === void 0 ? void 0 : _a._deviceId;
            if (typeof value.data === 'object' && toJson(value.data).length > 200 * 1024) {
                value.data = {
                    throwaway: true,
                };
            }
            if (inElectron) {
                const appendixKey = value.appendix || defaultAppendix;
                if (!dtMapInElectron.has(appendixKey)) {
                    dtMapInElectron.set(appendixKey, []);
                }
                const oldDt = dtMapInElectron.get(appendixKey);
                oldDt.push(toJson(value));
                dtMapInElectron.set(appendixKey, oldDt);
            }
            else if (value.data) {
                if (typeof value.data !== 'string')
                    value.data = toJson(value.data);
                const appendixKey = defaultAppendix;
                if (!dtMapInWeb.has(appendixKey)) {
                    dtMapInWeb.set(appendixKey, []);
                }
                const oldDt = dtMapInWeb.get(appendixKey);
                oldDt.push(value);
                dtMapInWeb.set(appendixKey, oldDt);
            }
            waitTrackList.set(key, null);
        });
        if (inElectron) {
            dtMapInElectron.forEach((value, key) => {
                const appendix = key === '__default' ? undefined : key;
                return window.electronLib.ipcChannelManage.send({
                    channel: 'fsManage',
                    functionName: 'writeToLogFile',
                    params: { data: value, appendix },
                });
            });
        }
        else {
            dtMapInWeb.forEach((value, key) => {
                this.debounceDbLoggerPut(value, key === '__default' ? 'normal' : key);
            });
        }
        used.forEach(key => {
            waitTrackList.delete(key);
        });
        await wait(1000);
    }
}
LoggerApiImpl.expiredSpan = 3 * 60 * 1000;
LoggerApiImpl._logger = new LoggerApiImpl();
const dataTrackerApiImp = LoggerApiImpl.getInstance();
api.registerLogicalApi(dataTrackerApiImp);
export default dataTrackerApiImp;
